"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var hmac_sha1_1 = __importDefault(require("crypto-js/hmac-sha1"));
var hmac_sha256_1 = __importDefault(require("crypto-js/hmac-sha256"));
var hmac_sha512_1 = __importDefault(require("crypto-js/hmac-sha512"));
var enc_base64_1 = __importDefault(require("crypto-js/enc-base64"));
var SignatureAlgorithm;
(function (SignatureAlgorithm) {
    SignatureAlgorithm[SignatureAlgorithm["HMACSHA1"] = 0] = "HMACSHA1";
    SignatureAlgorithm[SignatureAlgorithm["HMACSHA256"] = 1] = "HMACSHA256";
    SignatureAlgorithm[SignatureAlgorithm["HMACSHA512"] = 2] = "HMACSHA512";
})(SignatureAlgorithm = exports.SignatureAlgorithm || (exports.SignatureAlgorithm = {}));
function ParseSignature(sig) {
    if (sig.lastIndexOf("Signature ", 0) != 0) {
        return undefined;
    }
    var keyid = "";
    var signature = "";
    var algorithm = SignatureAlgorithm.HMACSHA1;
    var headers = [];
    var created;
    var expires;
    var pairs = sig.slice("Signature ".length).split(",");
    for (var i = 0; i < pairs.length; i++) {
        var kv = pairs[i].trim();
        var j = kv.indexOf("=");
        if (j <= 0) {
            continue;
        }
        var name = kv
            .slice(0, j)
            .trim()
            .toLowerCase();
        var value = kv.slice(j + 1);
        if (value[0] == '"' && value[value.length - 1] == '"') {
            value = value.slice(1, -1);
        }
        switch (name) {
            case "keyid":
                keyid = value;
                break;
            case "algorithm":
                algorithm = GetAlgorithmFromName(value);
                break;
            case "headers":
                headers = value.split(" ");
                break;
            case "signature":
                signature = value;
                break;
            case "created":
                created = parseInt(value);
                break;
            case "expires":
                expires = parseInt(value);
                break;
        }
    }
    return new Signature(keyid, signature, algorithm, headers, created, expires);
}
exports.ParseSignature = ParseSignature;
function GetAlgorithmFromName(algo) {
    switch (algo.toLowerCase()) {
        case "hmac-sha1":
            return SignatureAlgorithm.HMACSHA1;
        case "hmac-sha256":
            return SignatureAlgorithm.HMACSHA256;
        case "hmac-sha512":
            return SignatureAlgorithm.HMACSHA512;
    }
    return SignatureAlgorithm.HMACSHA1;
}
exports.GetAlgorithmFromName = GetAlgorithmFromName;
function getAlgorithmName(algo) {
    switch (algo) {
        case SignatureAlgorithm.HMACSHA1:
            return "hmac-sha1";
        case SignatureAlgorithm.HMACSHA256:
            return "hmac-sha256";
        case SignatureAlgorithm.HMACSHA512:
            return "hmac-sha512";
    }
}
var Signature = /** @class */ (function () {
    function Signature(keyid, signature, algorithm, headers, created, expires) {
        this.keyid = keyid;
        this.signature = signature;
        this.algorithm = algorithm;
        this.headers = headers;
        this.created = created;
        this.expires = expires;
    }
    Signature.prototype.doVerify = function (secret, headers, method, path) {
        var target = this.doConstructSignatureRequest(headers, method, path);
        target = this.hmac(target, secret);
        return target == this.signature;
    };
    Signature.prototype.doSignature = function (secret, headers, method, path) {
        var plaintext = this.doConstructSignatureRequest(headers, method, path);
        plaintext = this.hmac(plaintext, secret);
        var s = "Signature keyId=\"" + this.keyid + "\",algorithm=\"" + getAlgorithmName(this.algorithm) + "\"";
        s += ", headers=\"" + this.headers.join(" ") + "\", signature=\"" + plaintext + "\"";
        return s;
    };
    Signature.prototype.hmac = function (plaintext, secret) {
        switch (this.algorithm) {
            case SignatureAlgorithm.HMACSHA1:
                return this.doHAMCSHA1(plaintext, secret);
            case SignatureAlgorithm.HMACSHA256:
                return this.doHAMCSHA256(plaintext, secret);
            case SignatureAlgorithm.HMACSHA512:
                return this.doHAMCSHA512(plaintext, secret);
        }
    };
    Signature.prototype.doHAMCSHA1 = function (plaintext, secret) {
        return enc_base64_1.default.stringify(hmac_sha1_1.default(plaintext, secret));
    };
    Signature.prototype.doHAMCSHA256 = function (plaintext, secret) {
        return enc_base64_1.default.stringify(hmac_sha256_1.default(plaintext, secret));
    };
    Signature.prototype.doHAMCSHA512 = function (plaintext, secret) {
        return enc_base64_1.default.stringify(hmac_sha512_1.default(plaintext, secret));
    };
    Signature.prototype.doConstructSignatureRequest = function (headers, method, path) {
        var dst = "";
        for (var i = 0; i < this.headers.length; i++) {
            switch (this.headers[i]) {
                case "(request-target)":
                    dst += "(request-target): " + method.toLowerCase() + " " + path;
                    break;
                case "(created)":
                    dst += "(created): " + this.created;
                    break;
                case "(expires)":
                    dst += "(expires): " + this.expires;
                    break;
                default:
                    dst += this.headers[i] + ": " + headers[this.headers[i]].trim();
            }
            if (i < this.headers.length - 1) {
                dst += "\n";
            }
        }
        return dst;
    };
    return Signature;
}());
exports.Signature = Signature;
